<template>
    <div
        v-if="options && options.length"
        class="amount-grid"
    >
        <div
            v-for="option in options"
            :key="option"
            class="amount-box"
            :class="{ active: value == option }"
            @click="selectOpt(option)"
        >
            <span class="amount-value">{{ option }}</span>
            <span class="amount-currency">{{ currencyCode }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "CurrencyOptions",

    props: {
        options: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number],
            default: null,
        },
        currencyCode: {
            type: String,
            default: "",
        },
    },

    methods: {
        selectOpt(val) {
            this.$emit("input", val); // for v-model support
            this.$emit("change", val);
        },
    },
};
</script>

<style scoped>
.amount-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 18px;
}

.amount-box {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: white;
    padding: 10px 0;
    border-radius: 12px;
    text-align: center;
    cursor: pointer;
    transition: 0.2s ease;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.amount-box.active {
    background: linear-gradient(135deg, #6a5cf6, #8c4bff);
    border: 1px solid #b18cff;
    box-shadow: 0 0 12px rgba(140, 75, 255, 0.6);
}

.amount-value {
    font-size: 16px;
    font-weight: 600;
}

.amount-currency {
    font-size: 11px;
    opacity: 0.9;
}
</style>
